export class TariffOptionConfiguration {
  active: boolean;
  disabled: boolean;
  fields = {};
}
